var map = {
	"./images/dockIo.png": 1856
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1855;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/home/partners ^.*\/dockIo\.png$
// module id = 1855
// module chunks = 147